<template>
    <div>
        <Head :title="`${form.title}`"/>
        <h1 class="mb-8 text-3xl font-bold">
            <Link
                class="text-indigo-400 hover:text-indigo-600"
                :href="$route('attributes.index')"
            >
                Атрибути риболовлі
            </Link>
            <span class="text-indigo-400 font-medium">/</span>
            {{ form.title }}
        </h1>
        <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
            <form @submit.prevent="update" enctype="multipart/form-data">
                <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                    <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                        <text-input v-model="form.title" :error="form.errors.title" class="pb-8 pr-6 w-full"
                                    label="Назва"/>
                        <text-input v-model="form.price" :error="form.errors.price" class="pb-8 pr-6 w-full lg:w-1/2"
                                    label="Ціна" type="number"/>
                        <checkbox v-model="form.optional" :error="form.errors.optional"
                                  class="pb-8 pr-6 w-full lg:w-1/2"
                                  label="Чи може користувач обирати опцію"/>

                        <div class="flex w-full flex-col lg:flex-row">
                            <div class="flex-1 pt-4 mr-6">
                                <label for="lakesTable"
                                       class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">Озера на
                                    яких наявний атрибут:</label>
                                <table id="lakesTable"
                                       class="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                                    <thead
                                        class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                                    <tr>
                                        <th scope="col" class="p-4">
                                            <div class="flex items-center">
                                                <input
                                                    id="checkAllLakes"
                                                    class="w-4 h-4"
                                                    type="checkbox"
                                                    :checked="lakes && lakes.length === form.lakesId.length"
                                                    @change="checkAllLakes($event.target.checked)"
                                                >
                                                <label for="checkAllLakes" class="ml-2 capitalize">Всі</label>
                                            </div>
                                        </th>
                                        <th scope="col" class="py-3 px-6 capitalize">Назва озера</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="lake in lakes" :key="lake.id"
                                        class="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                                        <td class="w-4 p-4">
                                            <input type="checkbox" v-model="form.lakesId" :value="lake.id"
                                                   class="w-4 h-4">
                                        </td>
                                        <td class="py-3 px-6">{{ lake.name }}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="flex w-full flex-col lg:flex-row">
                            <div class="flex-1 pt-4 mr-6">
                                <label for="pointsTable"
                                       class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">Точки на
                                    яких наявний атрибут:</label>
                                <table id="pointsTable"
                                       class="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                                    <thead
                                        class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                                    <tr>
                                        <th scope="col" class="p-4">
                                            <div class="flex items-center">
                                                <input
                                                    id="checkAllPoints"
                                                    type="checkbox"
                                                    class="w-4 h-4"
                                                    :checked="points && points.length === form.pointsId.length"
                                                    @change="checkAllPoints($event.target.checked)"
                                                >
                                                <label for="checkAllPoints" class="ml-2 capitalize">Всі</label>
                                            </div>
                                        </th>
                                        <th scope="col" class="py-3 px-6 capitalize">Назва точки</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="point in points" :key="point.id"
                                        class="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                                        <td class="w-4 p-4">
                                            <input type="checkbox" v-model="form.pointsId" :value="point.id"
                                                   class="w-4 h-4">
                                        </td>
                                        <td class="py-3 px-6">{{ point.name }}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
                    <button
                        class="text-red-600 hover:underline" tabindex="-1" type="button"
                        @click="destroy"
                    >
                        Видалити
                    </button>
                    <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">
                        Оновити
                    </loading-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import {Head, Link} from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import Checkbox from "@/Shared/Checkbox"
import MultiSelectInput from "@/Shared/MultiSelectInput"
import SelectInput from "@/Shared/SelectInput"
import axios from "axios";

export default {
    components: {
        Checkbox,
        Head,
        Link,
        LoadingButton,
        TextInput,
        MultiSelectInput,
        SelectInput
    },
    layout: Layout,
    props: {
        attribute: Object,
    },
    remember: 'form',
    data() {
        return {
            form: this.$inertia.form({
                _method: 'put',
                title: this.attribute.title,
                price: this.attribute.price,
                optional: this.attribute.optional,
                lakesId: this.attribute.lakesIds,
                pointsId: this.attribute.pointsIds,
            }),
            lakes: [],
            points: [],
        }
    },
    watch: {
        'form.lakesId'() {
            this.fetchPoints()
        },
    },
    methods: {
        update() {
            this.form.put(this.$route('attributes.update', this.attribute.id))
        },
        destroy() {
            if (confirm('Ви впевнені що хочете видалити атрибут?')) {
                this.$inertia.delete(this.$route('attributes.destroy', this.attribute.id))
            }
        },
        async fetchPoints() {
            this.points = []
            if (this.form.lakesId) {
                const response = await axios.post(this.$route('all.lakes.points', {
                    lakes: this.form.lakesId
                }))
                this.points = await response.data.points;
            }
        },
        async fetchLakes() {
            const response = await axios.get(this.$route('all.lakes'))
            this.lakes = await response.data.lakes;
            await this.fetchPoints()
        },
        checkAllLakes(isChecked) {
            this.form.lakesId = isChecked ? [...this.lakes.map(lake => {
                return lake.id
            })] : []
        },
        checkAllPoints(isChecked) {
            this.form.pointsId = isChecked ? [...this.points.map(point => {
                return point.id
            })] : []
        },
    },
    mounted() {
        this.fetchLakes()
    }
}
</script>
